import { Queue } from "@mui/icons-material";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const axiosInstance = axios.create({
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

export const fetchFilteredRecords = createAsyncThunk(
    "recordsHandling/fetchFilteredRecords",
    async (filters, { dispatch, rejectWithValue }) => {
        try {
            const payload = {
                oneKeyId: filters.oneKeyId,
                ahpraId: filters.ahpraId,
                firstName: filters.firstName,
                lastName: filters.lastName,
                jobId: filters.jobId ? parseInt(filters.jobId, 10) : null,
                awaitingApproval: filters.awaitingApproval || false,
                // ...(filters.jobId !== null && { jobId: filters.jobId }), 
            };


            const response = await axiosInstance.post(
                `api/RecordsHandling/GetFilteredRecords`,
                payload
            );
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                dispatch(endUserSession());
                return rejectWithValue("Session expired. Logging out.");
            }
            return rejectWithValue(error.response?.data || "Error fetching records");
        }
    }
);

export const updateRecordStatus = createAsyncThunk(
    "recordsHandling/updateRecordStatus",
    async ({ queueId, oneKeyId, ahpraId, approvalStatus, userId, jobId }, { dispatch, rejectWithValue }) => {
        try {
            const requestBody = {
                QueueId: queueId,
                // OneKeyId: oneKeyId,
                // AhpraId: ahpraId,
                ApprovalStatus: approvalStatus,
                UserId: userId,
                // JobId: jobId
            };
            const response = await axiosInstance.post(
                `api/RecordsHandling/UpdateRecordStatus`,
                requestBody
            );
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                dispatch(endUserSession());
                return rejectWithValue("Session expired. Logging out.");
            }
            return rejectWithValue(error.response?.data || "Error updating record status");
        }
    }
);

const recordsHandlingSlice = createSlice({
    name: "recordsHandling",
    initialState: {
        records: [],
        status: "idle",
        error: null,
        updateStatus: "idle",
        updateError: null,
        isSessionValid: true,
    },
    reducers: {
        endUserSession: (state) => {
            state.isSessionValid = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFilteredRecords.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchFilteredRecords.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.records = action.payload;
            })
            .addCase(fetchFilteredRecords.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            .addCase(updateRecordStatus.pending, (state) => {
                state.updateStatus = "loading";
                state.updateError = null;
            })
            .addCase(updateRecordStatus.fulfilled, (state) => {
                state.updateStatus = "succeeded";
            })
            .addCase(updateRecordStatus.rejected, (state, action) => {
                state.updateStatus = "failed";
                state.updateError = action.payload;
            });
    },
});

export const { endUserSession } = recordsHandlingSlice.actions;
export default recordsHandlingSlice.reducer;
